/**
 * Internal error reporting for logging backends.
 *
 * Intentional exception to the "use the logging library" rule: these
 * console.error calls are the logging library's own internal error
 * reporting path. During backend initialization or write failures, the
 * logging library may not be available, so console is the only remaining
 * output channel.
 *
 * Unconditional rather than NODE_ENV-gated — this repo has no `no-console`
 * lint rule, and per testing-philosophy POLICY.md §9 (prefer simplification)
 * there's no reason to carry a production/development branch here.
 */

/**
 * Log a backend error.
 *
 * @param backendName - Name of the backend (e.g., "WorkerLogBackend")
 * @param context - What was happening when the error occurred (e.g., "write", "flush")
 * @param error - The error to log
 */
export function logDevError(
  backendName: string,
  context: string,
  error: unknown,
): void {
  console.error(`[${backendName}] ${context}:`, error);
}
